import { useMediaQuery, useTheme } from "@material-ui/core";
import * as React from "react";

import { RelodeTheme } from "../styles";

export const useDeviceSize = () => {
    const theme = useTheme<RelodeTheme>();
    const desktop = useMediaQuery(theme.breakpoints.up("md"), {
        noSsr: true,
    });
    const [size, setSize] = React.useState<"desktop" | "mobile">(() =>
        desktop ? "desktop" : "mobile"
    );

    React.useEffect(() => {
        setSize(desktop ? "desktop" : "mobile");
    }, [desktop]);

    return size;
};

const detectDevice = (userAgent: string) => {
    const isAndroid = () => Boolean(userAgent.match(/Android/i));
    const isIos = () => Boolean(userAgent.match(/iPhone|iPad|iPod/i));
    const isOpera = () => Boolean(userAgent.match(/Opera Mini/i));
    const isIEMobile = () => Boolean(userAgent.match(/IEMobile/i));

    const isMobile = Boolean(
        isAndroid() || isIos() || isOpera() || isIEMobile()
    );
    const isDesktop = Boolean(!isMobile);

    return {
        isAndroid,
        isIos,
        isIEMobile,
        isOpera,
        isMobile,
        isDesktop,
    };
};
export const useDevice = () => {
    const [state, setState] = React.useState<"desktop" | "mobile">();

    React.useEffect(() => {
        const isDesktop = detectDevice(navigator.userAgent);
        setState(isDesktop ? "desktop" : "mobile");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigator.userAgent]);

    return state;
};
